export const readMessageCountQuery = `{
              readMessageCount {
                saved
                following
                mustSee
              }
            }`;
